import styled from '@emotion/styled'

export const StyledSearchDrug = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`
